<template>
  <div class="statement-react">
    <remove-button @toggleOn="removeCommentStatement()" />
  </div>
</template>

<script>
  import StatementCommentRemove from "./StatementCommentRemove.ts";

  export default StatementCommentRemove;
</script>
